import { SummitFormattedText } from '@summit/models';
import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { SpotRunSite } from '../../spot/spot-run-site';

export class SettlementItemDetail extends EboObjectTO {
  settlementId: string;
  siteId: string;
  site: SpotRunSite;
  livePackages: number;
  liveAmount: number;

  constructor(jsonData?: Partial<SettlementItemDetail>) {
    super(jsonData);
    if (jsonData?.site) {
      this.site = new SpotRunSite(jsonData.site);
    }
  }

  toFormattedText(): SummitFormattedText | undefined {
    if (this.livePackages === 0) return undefined;
    const response = new SummitFormattedText();
    response.AddKeyValues(this.site.name, this.livePackages);
    return response;
  }
}
